import { Box, Flex } from '@mantine/core';
import Skeleton from 'react-loading-skeleton';
import PageHeader from '../../../../components/PageHeader';
import Table from '../../../../components/Table';
import { Wrapper } from '../../../Dashboard/style';
import { ProjectContainer } from '../../style';

interface ColumnDefinition {
  title: string;
  key: string;
}

interface ProjectsSkeletonProps {
  isLoading: boolean;
}

export function ProjectsSkeleton({ isLoading }: ProjectsSkeletonProps) {
  const columns: ColumnDefinition[] = [
    {
      title: 'Project Name',
      key: 'workflow_name'
    },
    {
      title: 'Report Type',
      key: 'report_type'
    },
    {
      title: 'Date Created',
      key: 'date_created'
    },
    {
      title: 'Date Updated',
      key: 'date_updated'
    },
    {
      title: 'Assigned To',
      key: 'assigned_to'
    }
  ];

  return (
    <>
      <Box bg="gray.0" pt="16" pb="0px" px="16" mb="-3px">
        <PageHeader title="Projects" />
      </Box>
      {/* @ts-ignore - Wrapper accepts $padding prop at runtime */}
      <Wrapper $padding="0px 16px">
        <ProjectContainer>
          <div className="header"></div>
          <Box className="box" p="16">
            <Flex mb="16" display="flex" align="start" justify="space-between">
              <Skeleton height={28} width={178} />
              <Skeleton height={28} width={245} />
            </Flex>
            {/* @ts-ignore - Table accepts isLoading prop at runtime */}
            <Table hasIndex={false} isLoading={isLoading} columns={columns} data={[]} />
          </Box>
        </ProjectContainer>
      </Wrapper>
    </>
  );
}
